<template>
  <div class="head-operation-wrap">
    <div class="header-operation-top-wrap">
      <div class="top-wrap">
        <span class="toLibrary" @click="toLibrary">华南师范大学图书馆</span>
        <span v-if="!userName" class="topLogin" @click="toLogin">
          <img src="/static/homeIcon/user.png" alt="" />
          <span class="title">统一认证登录</span>
        </span>
        <Adropdown v-else :menuList="updateMenuList" :nickName="nickName"></Adropdown>
      </div>
    </div>
    <div class="header-operation-bottom-wrap">
      <div class="header-operation-warp">
        <div class="head-left-wrap">
          <div @click="handleLogoLeft">
            <IconWrap url="/static/homeIcon/top-left.png"></IconWrap>
          </div>
          <div class="logo" @click="handleLogoRight">
            <IconWrap url="/static/homeIcon/top-right.png"></IconWrap>
          </div>
        </div>
        <div class="head-right-wrap">
          <HeaderMenu></HeaderMenu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {is_cloneDeep} from '@/utils/cloneDeep.js'
import {dropDownMenu, loginPath} from './components/configs/config'
import HeaderMenu from './components/HeaderMenu.vue'
import Adropdown from './components/Adropdown.vue'
export default {
  data() {
    return {
      dropDownMenu: [],
      path: loginPath.path
    }
  },
  components: {
    HeaderMenu,
    Adropdown
  },
  computed: {
    ...mapState({
      userName: state => state.user.userName,
      nickName: state => state.user.nickName,
      huashi: state => state.user.huashi,
      updateMenuList: state => state.headerMenu.updateMenuList
    }),
  },
  mounted() {
    this.setdropDownMenu()
  },
  methods: {
    setdropDownMenu() {
      
      let Menu = is_cloneDeep(dropDownMenu)
      if (this.showSysItem) {
        Menu[1].isShow = true
      }
      this.dropDownMenu = Menu
    },
    // 跳转到图书馆
    toLibrary() {
      window.open('https://lib.scnu.edu.cn/')
    },
    // 跳转登录页面
    toLogin() {
      window.location.href=`${loginPath.path}`
    },
    handleLogoLeft() {
      window.open('https://www.scnu.edu.cn')
    },
    handleLogoRight() {
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style></style>
